import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // Import root reducer
import customMiddleware from './middleware'; // Import custom middleware

// Configure the store using the rootReducer and customMiddleware
export const store = configureStore({
  reducer: rootReducer,
  middleware: customMiddleware, 
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
